
(function(){
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var W=1200, cx=600, top=70, bot=790, amp=78, turns=2.5, phase=-Math.PI/2;
  var g=document.getElementById("build");
  var NS="http://www.w3.org/2000/svg";
  function el(n,a){var e=document.createElementNS(NS,n);for(var k in a)e.setAttribute(k,a[k]);return e;}
  function xAt(t,side){var ang=phase+t*turns*2*Math.PI;return cx+(side?1:-1)*amp*Math.sin(ang);}
  function yAt(t){return top+t*(bot-top);}
  function strandPath(side){var d="",N=160;for(var i=0;i<=N;i++){var t=i/N;var x=xAt(t,side),y=yAt(t);d+=(i?"L":"M")+x.toFixed(1)+" "+y.toFixed(1);}return d;}
  [0,1].forEach(function(side){
    var p=el("path",{d:strandPath(side),fill:"none",stroke:"url(#"+(side?"chromeg2":"chromeg")+")","stroke-width":side?7:8,"stroke-linecap":"round",opacity:side?.9:1});
    var len=1600; p.setAttribute("class","anim-strand"); p.style.setProperty("--len",len);
    if(reduce){p.style.animation="none";p.removeAttribute("stroke-dasharray");}
    g.appendChild(p);
  });
  var RUNGS=34;
  for(var i=1;i<RUNGS;i++){
    var t=i/RUNGS; var x1=xAt(t,0),x2=xAt(t,1),y=yAt(t);
    var burgRung=(i%5===0);
    var r=el("line",{x1:x1,y1:y,x2:x2,y2:y,stroke:burgRung?"url(#burgg)":"url(#chromeg)","stroke-width":burgRung?2.6:1.8,opacity:(Math.abs(x1-x2)/(2*amp))*.5+.18});
    r.setAttribute("class","anim-rung"); r.style.animationDelay=(0.4+t*1.8)+"s";
    if(reduce){r.style.animation="none";r.style.opacity=r.getAttribute("opacity");}
    g.appendChild(r);
  }
  var NODES=[
    {t:0.075, side:1, lbl:"Peptide",     val:"Acetyl Hexapeptide-1", burg:false},
    {t:0.235, side:0, lbl:"MHCsc™",      val:"Conditioned Media",    burg:true },
    {t:0.40,  side:1, lbl:"Botanicals",  val:"30+ Cold-Pressed Oils",burg:false},
    {t:0.565, side:0, lbl:"Antioxidants",val:"Vitamin C · E · CoQ10",burg:false},
    {t:0.73,  side:1, lbl:"Vegan",       val:"100% Plant-Based",     burg:true },
    {t:0.895, side:0, lbl:"Free-Of",     val:"Parabens + 13 more",   burg:false}
  ];
  NODES.forEach(function(n,idx){
    var x=xAt(n.t,n.side), y=yAt(n.t);
    var out = n.side? (W-96) : 96;
    var elbow = n.side? x+46 : x-46;
    var cd="M"+x+" "+y+" L"+elbow+" "+y+" L"+out+" "+y;
    var cl=Math.abs(out-x)+2;
    var c=el("path",{d:cd,fill:"none",stroke:"rgba(236,231,223,.34)","stroke-width":1});
    c.setAttribute("class","anim-conn"); c.style.setProperty("--cl",cl); c.style.animationDelay=(1.6+idx*.16)+"s";
    if(reduce){c.style.animation="none";c.removeAttribute("stroke-dasharray");}
    g.appendChild(c);
    g.appendChild(el("circle",{cx:out,cy:y,r:2.5,fill:n.burg?"#B23F5B":"#C3C3CC","class":"anim-lab",style:"animation-delay:"+(1.8+idx*.16)+"s"}));
    var halo=el("circle",{cx:x,cy:y,r:16,fill:n.burg?"rgba(178,63,91,.45)":"rgba(210,210,220,.25)",filter:"url(#soft)","class":"anim-node",style:"animation-delay:"+(1.5+idx*.16)+"s"});
    g.appendChild(halo);
    var node=el("circle",{cx:x,cy:y,r:9,fill:n.burg?"url(#nodeb)":"url(#nodeg)",stroke:"rgba(255,255,255,.5)","stroke-width":.8,"class":"anim-node",style:"animation-delay:"+(1.55+idx*.16)+"s"});
    g.appendChild(node);
    var anchor=n.side?"end":"start";
    var lab=el("text",{x:out,y:y-9,"text-anchor":anchor,fill:"#ECE7DF","font-family":"Jost, sans-serif","font-size":"14","font-weight":"500","letter-spacing":".16em"});
    lab.textContent=n.lbl.toUpperCase();
    lab.setAttribute("class","anim-lab"); lab.style.animationDelay=(1.85+idx*.16)+"s";
    g.appendChild(lab);
    var sub=el("text",{x:out,y:y+15,"text-anchor":anchor,fill:"#A9ABAE","font-family":"Cormorant Garamond, serif","font-size":"20","font-style":"italic"});
    sub.textContent=n.val;
    sub.setAttribute("class","anim-lab"); sub.style.animationDelay=(1.95+idx*.16)+"s";
    g.appendChild(sub);
  });
})();
